module.exports = __webpack_public_path__ + "img/346.7e7d8d6f.png";